export const useUser = () => {
  const user = localStorage.getItem("userData");

  const parsedUser = user ? JSON.parse(user) : null;

  return {
    user: parsedUser,
  };
};
